import styled, { css } from 'styled-components'
import { ThemeSelectors } from '@at/design-system-foundation'

export const CarouselButtons = styled.button<{
    isLeftButton?: boolean
    hideRightArrow?: boolean
    hideLeftArrow?: boolean
}>`
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    border-radius: 20px;
    border: none;
    height: 34px;
    width: 34px;
    justify-content: center;
    align-items: center;
    background: ${({ theme }) => theme.color.button.bgFill.contrast.default};
    z-index: 4;
    cursor: pointer;
    transition: ease-in-out 0.2s;
    display: flex;

    box-shadow: ${({ theme }) => ThemeSelectors.getShadowFive(theme)};
    &:hover {
        transform: scale(1.1) translate(0, -50%);
        box-shadow: 0 1px 5px 0 #0000001a;
    }

    ${({ isLeftButton, hideLeftArrow, hideRightArrow }) => css`
        &#carousel-left-toggle {
            opacity: ${isLeftButton && hideLeftArrow ? 0 : 1};
        }
        &#carousel-right-toggle {
            opacity: ${!isLeftButton && hideRightArrow ? 0 : 1};
        }
    `}

    ${({ isLeftButton }) =>
        isLeftButton
            ? css`
                  left: 4%;
              `
            : css`
                  right: 4%;
              `}
`

export const CarouselWrapper = styled.div`
    position: relative;
`

export const CarouselContainer = styled.div`
    display: flex;
    width: 100%;
    padding-left: 0;
    scroll-snap-type: x mandatory;
    overflow: auto;
    scroll-behavior: smooth;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }
    z-index: 4;
`

export const CarouselItem = styled.a`
    list-style-type: none;
    transition: 0.3s ease-out;
    width: 100%;
    flex: 0 0 100%;
    scroll-snap-align: start;
    scroll-snap-stop: always;
    text-decoration: none;

    img {
        display: block;
    }
`

export const CarouselCounter = styled.div`
    position: absolute;
    bottom: 10%;
    transform: translate(-50%, 0);
    left: 50%;
    display: flex;
    align-items: center;
    z-index: 4;
`

export const CounterItem = styled.div<{ isSelected: boolean }>`
    ${({ isSelected }) =>
        isSelected
            ? css`
                  opacity: 1;
                  height: 10px;
                  width: 10px;
              `
            : css`
                  opacity: 0.7;
                  height: 8px;
                  width: 8px;
              `}
    border-radius: 20px;
    background: ${({ theme }) => theme.color.bgFill.overlay.opaque};
    padding: 1px;
    border: none;
    margin: 0 2px;
    transition: 0.3s;
    box-shadow: ${({ theme }) => ThemeSelectors.getShadowFive(theme)};
`

export const StyledCarouselBadge = styled.div`
    position: absolute;
    display: flex;
    justify-content: space-around;
    top: 5%;
    left: 4%;
    z-index: 5;
`

export const CarouselCountLabel = styled.a<{ $testBucket?: boolean }>`
    position: absolute;
    display: flex;
    align-items: center;
    text-decoration: none;
    background-color: ${({ theme }) => theme.color.bgFill.overlay.opaque};
    color: ${({ theme }) => theme.color.text.intense.default};
    border-radius: 4px;
    max-width: 108px;
    width: auto;
    height: ${({ $testBucket }) => ($testBucket ? '30px' : '36px')};
    padding: 8px;
    font-size: ${({ $testBucket }) => ($testBucket ? '13px' : '15px')};
    text-align: center;
    font-variation-settings: 'wght' 500;
    bottom: 7%;
    right: 4%;
    z-index: 1;
`
